
import { defineComponent, PropType } from 'vue';
import TimetableCourseCard from './TimetableCourseCard.vue';
import { Column, SectionInColumn } from '../types';

export default defineComponent({
  components: {
    TimetableCourseCard,
  },
  props: {
    column: { type: Array as PropType<Column>, required: true },
  },
  computed: {
    sectionList(): SectionInColumn[] {
      return this.column.filter((item) => typeof item === 'object') as SectionInColumn[];
    },
  },
  methods: {},
});
